onComplete(function() {
	// Scores are written on a scale of 10 ("8,8"); five stars are filled to the same share.
	var toPercentage = function(text) {
		var score = parseFloat(String(text).replace(',', '.').replace(/[^0-9.]/g, ''));
		if (isNaN(score)) {
			return null;
		}
		return Math.max(0, Math.min(100, score * 10)) + '%';
	};

	document.querySelectorAll('.js-rating').forEach(function(rating) {
		var score = rating.querySelector('.rating-score');
		var stars = rating.querySelector('.rating-stars');
		var percentage = score ? toPercentage(score.textContent) : null;
		if (stars && percentage) {
			stars.style.setProperty('--rating', percentage);
		}
	});

	// Every row of a score table gets the same stars as the totals, cloned so the icon markup stays the CMS's own.
	// Tables open in the text editor are left alone, otherwise the stars would be saved into the text.
	var template = document.querySelector('.rating-stars');
	if (!template) {
		return;
	}
	document.querySelectorAll('.rating-table tr').forEach(function(row) {
		var cells = row.querySelectorAll('td');
		if (cells.length !== 2 || row.querySelector('.rating-stars') || row.closest('[data-tinymce], [contenteditable]')) {
			return;
		}
		// The average row keeps an empty star cell, so its score lines up with the other scores.
		var percentage = toPercentage(cells[1].textContent);
		var cell = document.createElement('td');
		if (percentage && !/gemiddelde/i.test(cells[0].textContent)) {
			var stars = template.cloneNode(true);
			stars.style.setProperty('--rating', percentage);
			cell.appendChild(stars);
		}
		row.insertBefore(cell, cells[1]);
	});
});
